import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../_components/Header';
import moment from 'moment';
import { BusinessProfileActions } from '../_actions';
import Spinner from '../_components/Spinner';
import { Table } from 'react-bootstrap';
import NoResults from '../_components/NoResults';
import DropdownLastDays from '../_components/DropdownLastDays';
import ArrowImg from '../_assets/new/arrow.png';

const tabs = [
  { key: 1, title: 'Todos' },
  { key: 2, title: 'Activas' },
  { key: 3, title: 'Inactivas' },
];

function Vacancies() {
  const dispatch = useDispatch();
  const { dataRequest, isLoading, isLoadingReport } = useSelector(
    (state) => state.businessProfileReducers
  );
  const [activeTab, setActiveTab] = useState(1);

  useEffect(() => {
    dispatch(BusinessProfileActions.BusinessJobVacancy());
  }, [dispatch]);

  function changeTab(eventKey) {
    setActiveTab(eventKey);
    dispatch(BusinessProfileActions.SetTabVacancies(eventKey));
    dispatch(BusinessProfileActions.BusinessJobVacancy());
  }

  function renderTable() {
    if (isLoading) {
      return <Spinner />;
    }

    return (
      <Table striped hover className="table-principal">
        <thead>
          <tr>
            <th>Puesto</th>
            <th>ESCOLARIDAD MÍNIMA</th>
            <th>SUELDO OFRECIDO</th>
            <th>EXPERIENCIA</th>
            <th>ZONA DE TRABAJO</th>
            <th>FECHA DE ACTUALIZACIÓN</th>
            <th>ESTATUS</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {dataRequest?.results?.length ? (
            dataRequest.results.map((job) => (
              <tr key={job.id}>
                <td>{job.name}</td>
                <td>{job.scholarship}</td>
                <td>${job.salary}</td>
                <td>{job.experience}</td>
                <td>{job.location}</td>
                <td>{moment(job.modified).format('YYYY-MM-DD')}</td>
                <td>
                  <span className={'tag ' + (job.is_active ? 'active' : '')}>
                    {job.is_active ? 'Activo' : 'Inactivo'}
                  </span>
                </td>
                <td>
                  <Link to={'/vacancies-detail/' + job.id}>
                    <img src={ArrowImg} alt="Ver vacante" />
                  </Link>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">
                <NoResults />
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    );
  }

  function sendUrl(url) {
    dispatch(BusinessProfileActions.BusinessJobVacancy(url));
  }

  function downloadReport() {
    dispatch(BusinessProfileActions.downloadReport());
  }

  function handleDaysChange(days) {
    dispatch(BusinessProfileActions.SetVacanyDays(days));
    dispatch(BusinessProfileActions.BusinessJobVacancy());
  }

  return (
    <div className="dashboard-home">
      <Header />
      <div className="container">
        <div className="vacancies-secction" style={{ marginBottom: '31px' }}>
          <div className="row">
            <div className="col-md-4">
              <span className="title">Vacantes</span>
            </div>
            <div className="col-md-8 text-right buttons-report">
              <DropdownLastDays apply={handleDaysChange} />
              <button
                className="btn btn-primary float-right"
                onClick={downloadReport}
                disabled={isLoadingReport}
              >
                Descargar reporte
              </button>
            </div>
          </div>
        </div>

        <div className="table-paginator clear">
          <nav className="nav nav-tabs vacancies-tabs">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                className={
                  'nav-link' + (activeTab === tab.key ? ' active' : '')
                }
                onClick={() => changeTab(tab.key)}
              >
                {tab.title}
              </button>
            ))}
          </nav>
          {renderTable()}

          <div className="float-right">
            <span className="paginator-sme">
              {dataRequest?.page * 10 - 9}-{dataRequest?.page * 10} de{' '}
              {dataRequest?.count} registros
            </span>

            <button
              className="btn prev"
              disabled={!dataRequest?.previous}
              onClick={() => sendUrl(dataRequest?.previous)}
            ></button>
            <button
              className="btn next"
              disabled={!dataRequest?.next}
              onClick={() => sendUrl(dataRequest?.next)}
            ></button>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Vacancies };
